
import './1. Core/NP.ts';
import './1. Core/BaseObject.ts';
import './1. Core/Ajax.ts';
import './1. Core/Clr.ts';
import './1. Core/ScriptLoader.ts';
import './1. Core/FontImages.ts';
import './1. Core/Control.ts';
import './1. Core/Font.ts';
import './1. Core/ResourcesCore.ts';





import './Entries/authhtml.ts';
import './Entries/battlehtml.ts';

